<template>
  <div class="community-guidelines-copy-component">
    <div class="c-community-guidelines-copy has-padding-bottom-100">
      <section class="container has-mobile-container">
        <br />
        <div class="content">
          <h3 class="is-size-4">Keeping it Simple:</h3>
          <ol type="1">
            <li class="a-community-guidelines-paragraph">
              Post your own videos.
            </li>
            <li class="a-community-guidelines-paragraph">Keep it clean!</li>
            <li class="a-community-guidelines-paragraph">Be respectful.</li>
            <li class="a-community-guidelines-paragraph">Don't SPAM.</li>
            <li class="a-community-guidelines-paragraph">HAVE FUN!</li>
          </ol>

          <h3 class="is-size-4">Getting into the Details:</h3>
          <p class="a-community-guidelines-paragraph">
            The detailed Community Guidelines below have been created in order
            to help you understand the best practices as a member of the
            community. By utilizing CrowdFlik you are also subject to our Terms
            of Use.
          </p>
          <p class="a-community-guidelines-paragraph">
            What to do:
          </p>
          <ol type="1">
            <li class="a-community-guidelines-paragraph">
              Do share videos that you’ve taken. CrowdFlik is a great way to
              share your life through videos, but we have to ask that you don’t
              share videos of someone else’s life. Since users own the rights to
              all videos they have uploaded using our service, we ask that you
              respect their copyright ownership. If you want to express your
              excitement over a beautiful photo or video, it’s best to double
              tap on the post to like it!
            </li>
            <li class="a-community-guidelines-paragraph">
              Do share videos that are safe for people of all ages. Remember
              that our community is a diverse one, and that your posts are
              visible to people as young as 13 years old. While we respect the
              artistic integrity of videos, we have to keep our product and the
              content within it in line with our App Store’s rating for nudity
              and mature content. In other words, please do not post nudity or
              mature content of any kind.
            </li>
            <li class="a-community-guidelines-paragraph">
              Do treat others as you would like to be treated. People from
              around the world with different backgrounds come together to share
              moments on CrowdFlik, which is great, but it also means that not
              everyone will agree with what you think or believe. We ask that
              all users be polite and respectful in their interactions with
              other members.
            </li>
            <li class="a-community-guidelines-paragraph">
              Do have meaningful & genuine interactions. Self-promotion or
              commercial solicitation of any kind, in any form, is rarely
              well-received. Users often notice when you have posted the same
              comment elsewhere or have followed a large number of users to gain
              followers in return, so please be sincere with your exchanges on
              CrowdFlik.
            </li>
            <li class="a-community-guidelines-paragraph">
              Do have fun! CrowdFlik is the best way to quickly share beautiful
              videos of your life with others, and see the world through others’
              eyes.
            </li>
          </ol>
          <p class="a-community-guidelines-paragraph">
            It is important to note that overstepping the boundaries outlined
            below may result in a disabled account, or discontinued access to
            CrowdFlik, without warning.
          </p>
          <ol type="1">
            <li class="a-community-guidelines-paragraph">
              Don’t share videos that aren’t yours. This includes other people’s
              posts, and/or things that you have copied or collected from the
              Internet. Accounts that solely consist of only this type of
              content may be disabled at any time.
            </li>
            <li class="a-community-guidelines-paragraph">
              Don’t share videos that show nudity or mature content. If you
              wouldn’t show the photo or video you are thinking about uploading
              to a child, or your boss, or your parents, you probably shouldn’t
              share it on CrowdFlik. The same rule applies to your profile
              photo. Accounts found sharing nudity or mature content will be
              disabled and your access to CrowdFlik may be discontinued.
            </li>
            <li class="a-community-guidelines-paragraph">
              Don’t share videos of illegal content. If we find you sharing
              prohibited or illegal content, including photographs or videos of
              extreme violence or gore, your account may be disabled and we will
              take appropriate action, which may include reporting you to the
              authorities.
            </li>
            <li class="a-community-guidelines-paragraph">
              Don’t spam. CrowdFlik is a place where people can share beautiful
              moments from their lives, and when you engage in self-promotional
              behavior of any kind on CrowdFlik it makes users who have shared
              that moment with you feel sad inside. This guideline includes
              repetitive comments, as well as service manipulation in order to
              self-promote, and extends to commercial spam comments, such as
              discount codes or URLs to websites. We ask that you keep your
              interactions on CrowdFlik meaningful and genuine.
            </li>
            <li class="a-community-guidelines-paragraph">
              Don’t be rude. CrowdFlik is a friendly place where everyone should
              feel safe and comfortable sharing their lives through videos. It
              is not an appropriate place to abuse, attack, harass, or
              impersonate others. If we receive valid complaints about your
              conduct, we’ll send a warning or disable your account.
              Alternatively, we’d recommend users block and/or report all
              meanies & trolls to prevent further issues.
            </li>
            <li class="a-community-guidelines-paragraph">
              Don’t promote or glorify self-harm. While CrowdFlik is a place
              where people can share their lives with others through videos, any
              account found encouraging or urging users to embrace anorexia,
              bulimia, or other eating disorders; or to cut, harm themselves, or
              commit suicide will result in a disabled account without warning.
              We believe that communication regarding these behaviors in order
              to create awareness, come together for support and to facilitate
              recovery is important, but that CrowdFlik is not the place for
              active promotion or glorification of self-harm.
            </li>
          </ol>
          <p class="a-community-guidelines-paragraph">
            Additional things to remember:
          </p>
          <p class="a-community-guidelines-paragraph">
            CrowdFlik is a diverse community, and it is likely that you will
            come across things that offend you. If you are offended by a video
            that may not violate any of the above guidelines, we’d suggest you
            navigate away from the account, or even use our blocking feature. If
            you are unsure about the content, you can report it utilizing our
            built-in reporting functionality in order to bring it to the
            CrowdFlik Team’s attention.
          </p>
          <p class="a-community-guidelines-paragraph">
            If you find that one of your FLIKs has been uploaded to another
            user’s profile, try not to panic. It is likely a misunderstanding
            and not ill-intended. A good first step is to comment on the post &
            politely ask that they take the content down. If that doesn’t work,
            please file a DMCA report so that we may investigate. You might find
            yourself wanting to post a screenshot of the offending account to
            your account in order to draw attention to the situation or user,
            but that’s often not the best way to go about resolving the issue.
            We do not encourage singling out the user, as it may be classified
            as harassment, which violates our guidelines. If you think that
            there is immediate cause for concern, you can send a report to the
            CrowdFlik Team. Please provide all necessary information for us to
            quickly respond to an issue that urgently needs our attention, this
            includes image or video descriptions & dates, URLs, and valid
            usernames. If you believe you will have trouble following these
            guidelines we’d suggest finding an alternative photo sharing
            service, as CrowdFlik may not be the best place for you. We value
            these guidelines, and believe that they will help keep CrowdFlik a
            safe & fun place for everyone. If you need further information, you
            can check out our Support Center and Terms of Use.
          </p>
          <p class="a-community-guidelines-paragraph">The CrowdFlik Team</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommunityGuidelinesCopyComponent"
};
</script>

<style scoped lang="scss"></style>
